import { Dispatch } from "redux";
import * as borDocActions from "../features/merchant/doc";
import * as borBizActions from "../features/merchant/biz";
import * as borRepActions from "../features/merchant/rep";
import * as borBankActions from "../features/merchant/bankSlice";
import {
  setUserFirstName,
  setUserLastName,
} from "@funded-here-interface/common/src/features/auth/authSlice_Investor";

export const initializeName = (dispatch: Dispatch, data: any) => {
  dispatch(setUserFirstName({ userFirstName: data.userFirstName }));
  dispatch(setUserLastName({ userLastName: data.userLastName }));
};

export const initializeDocuments = (dispatch: Dispatch, data: any) => {
  dispatch(borDocActions.setProofDoc({ proof: data.proofOfAddress || [] }));
  dispatch(
    borDocActions.setBusinessDoc({ business: data.businessProfile || [] })
  );
  dispatch(
    borDocActions.setShareDoc({
      share: data.shareHoldersDirectorsRegisters || [],
    })
  );
  dispatch(borDocActions.setBankDoc({ bank: data.bankStatement || [] }));
  dispatch(
    borDocActions.setBalance({ balance: data.balanceSheetPAndLStatement || [] })
  );
};

export const initializeBusinessDetails = (dispatch: Dispatch, data: any) => {
  dispatch(borBizActions.setCompanyRedux({ company: data.companyName }));
  dispatch(
    borBizActions.setRegNumberRedux({ regNumber: data.companyRegistrationNo })
  );
  dispatch(
    borBizActions.setLegalStructureRedux({
      legalStructure: data.legalStructure,
    })
  );
  dispatch(
    borBizActions.setLegalStructureOthersRedux({
      legalStructureOthers: data.legalStructureOthers,
    })
  );
  dispatch(
    borBizActions.setCountryOfIncorpRedux({
      countryOfIncorp: data.countryOfIncorporation,
    })
  );
  dispatch(
    borBizActions.setCountryOfDomicileRedux({
      countryOfDomicile: data.countryOfDomicile,
    })
  );
  dispatch(borBizActions.setAddressRedux({ address: data.legalEntityAddress }));
  dispatch(borBizActions.setPostalRedux({ postal: data.postalCode }));
  dispatch(borBizActions.setWebsiteRedux({ website: data.website }));
  dispatch(
    borBizActions.setTurnOverRedux({
      turnover: data.previousYearClosingInventory,
    })
  );
  dispatch(borBizActions.setPhoneNumber({ phoneNumber: data.phoneNumber }));
  dispatch(
    borBizActions.setIndustryGroupRedux({ industryGroup: data.industryGroup })
  );
  dispatch(
    borBizActions.setIndustryDropdownValuesRedux({
      industryDropdownValues: data.industryDropdownValues,
    })
  );
  dispatch(
    borBizActions.setTypeOfInstituteRedux({ typeOfInstitute: data.industry })
  );
  dispatch(
    borBizActions.setIncorporationDateRedux({
      incorporationDate: data.companyStartDate,
    })
  );
};

export const initializeRepresentativeDetails = (
  dispatch: Dispatch,
  data: any
) => {
  dispatch(borRepActions.setRepFirstName({ repFirstName: data.repFirstName }));
  dispatch(borRepActions.setRepLastName({ repLastName: data.repLastName }));
  dispatch(borRepActions.setRepEmail({ repEmail: data.repEmail }));
  dispatch(borRepActions.setRepTitle({ repTitle: data.repTitle }));
  dispatch(
    borRepActions.setMerchantTitle({ merchantTitle: data.merchantTitle })
  );
  dispatch(
    borRepActions.setShareholderDirector({
      shareholdersDirectors: data.shareHoldersDirectors || [],
    })
  );
};

export const initializeBankDetails = (dispatch: Dispatch, data: any) => {
  dispatch(borBankActions.setBankNameRedux({ bankName: data.bankName }));
  dispatch(
    borBankActions.setAccountTypeRedux({ accountType: data.accountType })
  );
  dispatch(
    borBankActions.setAccountNoRedux({ accountNumber: data.accountNumber })
  );
  dispatch(
    borBankActions.setAccountHolderNameRedux({
      accountHolderName: data.accountHolderName,
    })
  );
  dispatch(borBankActions.setSwiftCodeReduct({ swiftCode: data.swiftCode }));
};
